import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksRecomendedStaff(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF]: _getRegulationsStagesPlanWorksRecomendedStaff,
}
